module.exports = __webpack_public_path__ + "static/logo-android-white-bfdbd9d45cd5b60ae1256c8d0425d354.svg";